import { FC } from "react";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { BillingPageV2SetupSection } from "./BillingPageV2SetupSection/BillingPageV2SetupSection";
import { BillingPageV2InvoiceSection } from "./BillingPageV2InvoiceSection/BillingPageV2InvoiceSection";
import { BillingPageV2ClientsSection } from "./BillingPageV2ClientsSection/BillingPageV2ClientsSection";
import styles from "./BillingPageV2.module.scss";

interface BillingPageV2Props {
    canManageBilling: boolean;
}

export const BillingPageV2: FC<BillingPageV2Props> = ({ canManageBilling }) => {
    const { organizationBillingClientsBreakdown } = useTypedFlags();

    return (
        <div className={styles.layout}>
            <BillingPageV2SetupSection canManageBilling={canManageBilling} />
            <BillingPageV2InvoiceSection canManageBilling={canManageBilling} />
            {organizationBillingClientsBreakdown ? (
                <BillingPageV2ClientsSection />
            ) : null}
        </div>
    );
};
